import Vue from 'vue';
import axios from 'axios';
import * as files from '../../../fileUtils';
import '../../../filters';
import moment from 'moment';

export default {
  name: 'Messages',
  props: ['messagesData'],
  components: {
    AttachmentsComp: require('../../../components/attachments.vue').default,
  },
  data: function () {
    return {
      appId: -1,
      steps: [
        {
          target: '#btnAddAttach',  // We're using document.querySelector() under the hood
          content: this.$t('tour.btnAddAttach'),
          params: {
            placement: 'right'
          }
        }
      ],
      tourCallbacks: {
        onStart: this.tourStartCallback,
        onStop: this.tourStopCallback
      },
      bIsTourCompleted: false,
      messages: [],
      permissions: { add: true, delete: true, edit: true },
      options: { pageSize: 5, total: 0, page: 1 },
      newMessage: '',
      attachmentsProps: { mimeTypes: '', multiple: false },
      files: null,
      file: '',
      message: '',
      editingMessage: {},
      showMessageFlag: false,
      totalRow: 0,
      bShowEdit: true,
      attachments: {
        files: [], permissions: { add: true, delete: true, download: true, }, sort: true, download: this.download,
        mimeTypes: 'image/png,image/jpeg,application/pdf,application/msword,application/excel', multiple: false, maxFilesNumber: 3
      },
    }
  },
  created() {
    this.init();
    this.$root.$on('unread_messages_updated', this.init);
    this.isTourCompleted();
  },
  mounted: function () {
    //if (this.$tours['portalTour'])
    //  setTimeout(() => { this.$tours['portalTour'].start(); }, 2000);
  },
  computed: {
    selectedFiles: function () {
      var f = '';
      if (this.files != null)
        for (var i = 0; i < this.files.length; ++i)
          f += (this.files[i].length > 0 ? ', ' : '') + this.files[i].name;
      return f;
    },
    newMessageLength: function () {
      return this.newMessage.length;
    },
    languageLocale: function () {
      return this.$i18n.locale;
    },
  },
  watch: {
    languageLocale: function (value) {
      if (this.newMessageLength > 5)
        this.steps = [
          {
            target: '#btnAddAttach',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddAttach'),
            params: {
              placement: 'right'
            }
          },
          {
            target: '#btnAddMsg',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddMsg'),
            params: {
              placement: 'left'
            }
          }
        ];
      else
        this.steps = [
          {
            target: '#btnAddAttach',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddAttach'),
            params: {
              placement: 'right'
            }
          }
        ];
    },
    newMessageLength: function (value) {
      if (value > 5) {
        this.steps = [
          {
            target: '#btnAddAttach',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddAttach'),
            params: {
              placement: 'right'
            }
          },
          {
            target: '#btnAddMsg',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddMsg'),
            params: {
              placement: 'left'
            }
          }
        ];
        if (this.bIsTourCompleted === false)
          this.$tours['portalTour'].start();
      }
      else 
        this.steps = [
          {
            target: '#btnAddAttach',  // We're using document.querySelector() under the hood
            content: this.$t('tour.btnAddAttach'),
            params: {
              placement: 'right'
            }
          }
        ];
    },
  },
  methods: {
    init() {
      if (this.messagesData) {
        this.appId = this.messagesData.appId;
        this.bShowEdit = this.messagesData.bShowEdit !== undefined ? this.messagesData.bShowEdit : true;
        this.attachmentsProps = { mimeTypes: this.messagesData.mimeTypes, multiple: this.messagesData.multiple };
        this.permissions = this.messagesData.permissions;
        this.getMessages();
      }
    },
    isTourCompleted() {
      var sTour = this.$localStorage.get('_tour.messages');
      this.bIsTourCompleted = (sTour !== null && sTour === 'completed');
    },
    tourStartCallback() {
      // do nothing
    },
    tourStopCallback() {
      this.bIsTourCompleted = true;
      this.$localStorage.set('_tour.messages', 'completed');
    },
    pageChange(pInfo) {
      var parameters = {
        Options: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          Total: pInfo.totalRow
        },
        PortalApplicationId: this.appId
      };
      this.getMessagesAux(parameters);
    },
    getMessagesAux(parameters) {
      axios.post('/ApplicationMessage/GetItems', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
            this.messages = response.data.items;
            if (this.options.page > 1 && this.messages.length == 0) {
              this.options.page--;
              this.getMessages();
            }
          }
          else {
            this.messages = [];
            this.options.total = 0;
            this.showMessage(response.data.data.text, 1);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getMessages() {
      axios.post('/ApplicationMessage/GetItems', { PortalApplicationId: this.appId, Options: this.options })
        .then(response => {
          if (response.data.data.status == 0) {
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
            this.messages = response.data.items;
            if (this.options.page > 1 && this.messages.length == 0) {
              this.options.page--;
              this.getMessages();
            }
          }
          else {
            this.messages = [];
            this.options.total = 0;
            this.showMessage(response.data.data.text, 1);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    addMsg() {
      if (this.newMessage == '') {
        this.showMessage(this.$t('messages.noMessageFound'), 1);
        return;
      }

      //console.log(this.newMessage);
      this.newMessage = this.newMessage.replace(/\r?\n/g, "\r\n");
      console.log(this.newMessage);
      axios.post('/ApplicationMessage/Insert', { PortalApplicationId: this.appId, Message: this.newMessage })
        .then(this.insertAttachments)
        .then(function (processAttachmentsResponse) {
          if (processAttachmentsResponse.data.data.status != 0)
            throw new Error('Cannot add attachments.');
          else
            this.showMessage(this.$t('messages.MesssageSentSuccess'), 0);
          this.newMessage = '';
          this.files = null;
          this.file = null;
          this.getMessages();
        }.bind(this))
        .catch((e) => {
          this.showMessage(e.message, 1);
        })
    },
    insertAttachments(addResponse) {
      if (addResponse.data.data.status != 0)
        throw new Error('Cannot add message');
      else {
        if (this.files == null || this.files.length == 0)
          return { data: { data: { status: 0 } } };
        else {
          var formData = new FormData();
          formData.append("messageId", addResponse.data.id);
          for (var i = 0; i < this.files.length; ++i)
            formData.append("uploadFiles", this.files[i]);

          return axios.post('/ApplicationMessageAttachment/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
      }
    },
    deleteMsg(id) {
      axios.post('/ApplicationMessage/Delete', { Value: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.showMessage(this.$t('messages.MesssageDeletedSuccess'), 0);
            this.getMessages();
          }
          else
            this.showMessage(response.data.data.text, 0);
        })
        .catch(e => { this.$router.push('/login'); return false; });
    },
    gotoApp(item) {
      window.location.href = '/app/' + item.applicationType + '/' + item.portalApplicationId;
    },
    editMsg(item) {
      var id = item.messageId;
      axios.post('/ApplicationMessage/GetItem', { Value: id })
        .then(response => {
          if (response.data.data.status == 0) {
            var msg = response.data.item;
            this.editingMessage = msg;
            this.attachments.permissions.add = msg.unread && this.permissions.edit;
            this.attachments.permissions.delete = msg.unread && this.permissions.edit;
            this.editingMessage.editable = this.editingMessage.unread && this.permissions.edit;

            var files = response.data.item.attachments;
            this.attachments.files = [];
            for (var i = 0; i < msg.attachments.length; ++i) {
              var file = files[i];
              this.attachments.files.push({ attachmentId: file.attachmentId, seqId: 0, deleted: false, fileName: file.fileName });
            }

            this.showMessageFlag = true;

            if (!item.customerMessage)
              Vue.nextTick(function () {
                item.unread = false;
              });
          }
          else
            this.showMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    saveChanges() {
      axios.post('/ApplicationMessage/Update', { MessageId: this.editingMessage.messageId, Message: this.editingMessage.message })
        .then(response => {
          this.getMessages();
          if (response.data.data.status == 0) {
            var newFiles = [];
            var deleteFiles = [];
            this.attachments.files.forEach(function (file) {
              if (file.id < 0) // new
                newFiles.push(file.file);
              else if (file.deleted)
                deleteFiles.push(file.id);
            });

            if (deleteFiles.length > 0 || newFiles.length > 0) {
              this.processAttachments(this.editingMessage.messageId, newFiles, deleteFiles)
                .then(response => {
                  if (response.data.data.status == 0) {
                    this.showMessage(this.$t('messages.MesssageSavedSuccess'), 0);
                    this.closeDialog();
                  }
                  else
                    this.showMessage(response.data.data.text, 1);
                });
            }
            else {
              this.showMessage(this.$t('messages.MesssageSavedSuccess'), 0);
              this.closeDialog();
            }
          }
          else
            this.showMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    processAttachments(messageId, uploadFiles, deleteFiles) {
      var formData = new FormData();
      formData.append("messageId", messageId);
      for (var i = 0; i < uploadFiles.length; ++i)
        formData.append("uploadFiles", uploadFiles[i]);
      for (var i = 0; i < deleteFiles.length; ++i)
        formData.append("deleteFiles", deleteFiles[i]);

      return axios.post('/ApplicationMessageAttachment/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    },
    download(id) {
      axios.post('/ApplicationMessageAttachment/Download', { Value: id }, { responseType: 'blob' })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .catch((err) => {
          console.log(err)
        })
    },
    closeDialog() {
      this.editingMessage = '';
      this.showMessageFlag = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getMessages();
    },
    onSelected(e) {
      this.files = e;
    },
    showMessage(msg, type) {
      if (msg && msg.length > 0) {
        this.message = msg;
        if (type == 1)
          this.message += ' If the problem repeats please contact Support';
        this.$notify({ duration: 10000, group: 'app', text: msg, type: type == 1 ? 'warn' : '' }); // title: '',
        //this.showMessageFlag = true;
      }
    },
  },
}
